module.exports = __webpack_public_path__ + "img/tab_order_pre@2x.356b9bfe.png";